module.exports = __webpack_public_path__ + "media/images/sports_coaching/card-desktop@3x-5287381b6b13082723ba6f497e14510e.jpg";